<template>
  <p>...</p>
</template>

<script>
import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'CrefopayNotification',
  components: {errorMessages},
  computed: mapState([
    'locale'
  ]),
  data: function () {
    return {
      orderID: null,
      paymentMethod: null,
      paymentInstrumentID: null
    }
  },
  created () {
    this.orderID = this.$route.params.orderID
    this.paymentMethod = this.$route.params.paymentMethod
    this.paymentInstrumentID = this.$route.params.paymentInstrumentID
    this.process()
  },
  methods: {
    process () {
      let redirectRoute = null

      // Funktion zur Login überprüfung auslagern in global scope
      if (typeof window.sessionStorage.jwt !== 'undefined' && (window.sessionStorage.expires - Math.floor(Date.now() / 1000)) > 0) {
        redirectRoute = 'UserCrefopay'
      } else {
        redirectRoute = 'RegisterPaymentConfirm'
      }

      this.$router.replace({name: redirectRoute, params: {orderID: this.orderID, paymentMethod: this.paymentMethod, paymentInstrumentID: this.paymentInstrumentID}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CrefopayNotification.vue